import { render, staticRenderFns } from "./BeneficiariesManager.vue?vue&type=template&id=2a373635&scoped=true&"
import script from "./BeneficiariesManager.vue?vue&type=script&lang=js&"
export * from "./BeneficiariesManager.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiariesManager.vue?vue&type=style&index=0&id=2a373635&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a373635",
  null
  
)

export default component.exports